import common from '../../common'

export const valueTable = {
  ...common.constants
}



// WEBPACK FOOTER //
// ./src/register/configs/commonConfig.js